import { render, staticRenderFns } from "./v-movable.vue?vue&type=template&id=7547c837&scoped=true"
import script from "./v-movable.vue?vue&type=script&lang=js"
export * from "./v-movable.vue?vue&type=script&lang=js"
import style0 from "./v-movable.vue?vue&type=style&index=0&id=7547c837&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7547c837",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7547c837')) {
      api.createRecord('7547c837', component.options)
    } else {
      api.reload('7547c837', component.options)
    }
    module.hot.accept("./v-movable.vue?vue&type=template&id=7547c837&scoped=true", function () {
      api.rerender('7547c837', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/muiutils/views/movable/v-movable.vue"
export default component.exports